"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = void 0;
var http_client_1 = require("./http-client");
var safari_client_1 = require("./safari-client");
var helpers_1 = require("../helpers");
exports.client = (0, helpers_1.isSafari)() ? safari_client_1.safariClient : http_client_1.httpClient;
